import { IconConfig } from "../types";

export const blueHouse: IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 60 60",
  elements: [
    {
      type: 'g',
      id: "home_2_houseblue",
      transform: "translate(0 -0.001) scale(1)",
      children: [
        {
          type: 'g',
          id: "house_blue_Group_330",
          transform: "translate(47.699 38.552)",
          children: [
            {
              type: 'g',
              id: "house_blue_Group_329",
              children: [
                {
                  type: 'path',
                  id: "house_blue_Path_82",
                  d: "M439.859,354.319a1.088,1.088,0,1,0,.319.77A1.1,1.1,0,0,0,439.859,354.319Z",
                  transform: "translate(-438 -354)"
                }
              ]
            }
          ]
        },
        {
          type: 'g',
          id: "house_blue_Group_332",
          transform: "translate(0 0.001)",
          children: [
            {
              type: 'g',
              id: "house_blue_Group_331",
              children: [
                {
                  type: 'path',
                  id: "house_blue_Path_83",
                  d: "M54.668,53.58H49.877V43.452a1.089,1.089,0,0,0-2.178,0V53.58H13.286V43.343a1.089,1.089,0,1,0-2.178,0V53.58H8.059V24.939L27.879,9.466,47.7,24.939V35.285a1.089,1.089,0,1,0,2.178,0V26.64l.19.149a1.089,1.089,0,0,0,1.44-.088l3.928-3.928a1.089,1.089,0,0,0-.1-1.629l-6.547-5.112V5.119A1.089,1.089,0,0,0,47.7,4.03H41.387A1.089,1.089,0,0,0,40.3,5.119V9.4L28.549.231a1.089,1.089,0,0,0-1.34,0L.422,21.143a1.089,1.089,0,0,0-.1,1.629L4.25,26.7a1.089,1.089,0,0,0,1.44.088l.19-.149V53.58H1.089a1.089,1.089,0,0,0,0,2.178H54.668a1.089,1.089,0,0,0,0-2.178ZM42.476,6.208H46.61v8.123L42.476,11.1ZM5.109,24.479,2.733,22.1,27.879,2.471,53.024,22.1l-2.376,2.376L28.549,7.226a1.089,1.089,0,0,0-1.34,0Z",
                  transform: "translate(0 -0.001)"
                }
              ]
            }
          ]
        },
        {
          type: 'g',
          id: "house_blue_Group_334",
          transform: "translate(16.335 23.741)",
          children: [
            {
              type: 'g',
              id: "house_blue_Group_333",
              children: [
                {
                  type: 'path',
                  id: "house_blue_Path_84",
                  d: "M172,218H151.089A1.089,1.089,0,0,0,150,219.089V240a1.089,1.089,0,0,0,1.089,1.089H172A1.089,1.089,0,0,0,173.087,240V219.089A1.089,1.089,0,0,0,172,218Zm-11.544,20.909h-8.276v-8.276h8.276Zm0-10.455h-8.276v-8.276h8.276Zm10.455,10.455h-8.276v-8.276h8.276Zm0-10.455h-8.276v-8.276h8.276Z",
                  transform: "translate(-150 -218)"
                }
              ]
            }
          ]
        },
        {
          type: 'g',
          id: "house_blue_Group_336",
          transform: "translate(11.108 37.953)",
          children: [
            {
              type: 'g',
              id: "house_blue_Group_335",
              children: [
                {
                  type: 'path',
                  id: "house_blue_Path_85",
                  d: "M103.089,348.506A1.089,1.089,0,0,0,102,349.6v.018a1.089,1.089,0,1,0,2.178,0V349.6A1.089,1.089,0,0,0,103.089,348.506Z",
                  transform: "translate(-102 -348.506)"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}
